document.addEventListener("DOMContentLoaded", function() {
  const subheading = document.querySelector('.collection-subheading');
  if (subheading) {
    const originalText = subheading.textContent.trim();
    const firstPeriodIndex = originalText.indexOf('.');
    const firstQuestionMarkIndex = originalText.indexOf('?');
    const firstEndIndex = (firstPeriodIndex !== -1 && firstQuestionMarkIndex !== -1)
      ? Math.min(firstPeriodIndex, firstQuestionMarkIndex)
      : (firstPeriodIndex !== -1 ? firstPeriodIndex : firstQuestionMarkIndex);
    // Proceed if either a period or question mark was found
    if (firstEndIndex !== -1 && firstEndIndex < originalText.length - 1) {
      const firstSentence = originalText.substring(0, firstEndIndex + 1);
      const remainingText = originalText.substring(firstEndIndex + 1).trim();
      subheading.innerHTML = `${firstSentence} `;
      // Create the "Read more" link
      const toggleLink = document.createElement('a');
      toggleLink.href = "javascript:void(0);";
      toggleLink.classList.add('toggle-subheading');
      toggleLink.innerHTML = "Read more";
      // Append the "Read more" link
      subheading.appendChild(toggleLink);
      toggleLink.addEventListener('click', function() {
        if (toggleLink.innerHTML === "Read more") {
          subheading.innerHTML = `${firstSentence} ${remainingText} `;
          toggleLink.innerHTML = "Read less";
          subheading.appendChild(toggleLink);
        } else {
          subheading.innerHTML = `${firstSentence} `;
          toggleLink.innerHTML = "Read more";
          subheading.appendChild(toggleLink);
        }
      });
    }
  }
});